import React from 'react'
import styles from './CustomTableHeader.module.css'
import { Button } from 'react-bootstrap'
import { SpaceActions } from '../../../SpacesTabs'

const CustomTableHeader = ({
  title,
  badge,
  buttons = [],
  spaceId,
  spaceName,
  onEditSpace,
  onDeleteSpace,
  isSpace = false
}) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.leftSection}>
        <div className={styles.titleSection}>
          <h2 className={styles.title}>{title}</h2>
          {badge && <span className={styles.badge}>{badge}</span>}
          {isSpace && spaceId && spaceId !== 'all' && spaceId !== 'archive' && (
            <SpaceActions
              spaceId={spaceId}
              spaceName={spaceName}
              onEditSpace={onEditSpace}
              onDeleteSpace={onDeleteSpace}
            />
          )}
        </div>
      </div>
      <div className={styles.rightSection}>
        {buttons.map((button, index) => {
          if (button.type === 'custom_button') {
            return <React.Fragment key={button.id || button.key || index}>{button.component}</React.Fragment>
          }
          return (
            <Button key={index} onClick={button.onClick} className={`${styles.button} ${button.className || ''}`}>
              {button.icon && <img src={button.icon} alt="" className={styles.buttonIcon} />}
              {button.text}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default CustomTableHeader
